import React from "react";
import styled from "styled-components";
import { COLORS } from "../../styles/colors";

export interface WxParagraphProps {
  title: string;
  text?: string;
}

const WxParagraph = ({ title, text = "" }: WxParagraphProps) => {
  return (
    <Container>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </Container>
  );
};

const Container = styled.div`
  font-size: 0.75rem;
  max-width: 44ch;

  h2,
  p {
    color: ${COLORS.black};
    text-align: center;
  }

  h2 {
    text-transform: uppercase;
    margin-bottom: 0.3125rem;
  }

  p {
    font-weight: 300;
  }
`;

export default WxParagraph;
